<template>
    <button @click="toggle" class="menu-button">
        <span class="menu-button__icon-bar"></span>
        <span class="menu-button__icon-bar"></span>
        <span class="menu-button__icon-bar"></span>
    </button>
</template>

<script lang="ts">
import { Component, Vue, Emit } from 'vue-property-decorator';
@Component({})
export default class HamburgerMenu extends Vue {
    @Emit('toggle')
    public toggle(e: Event) {
        return e;
    }
}
</script>
